import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'
import { isEmpty, kebabCase } from 'lodash'
import { Document } from 'store/products/types'
import { ReviewRows } from 'dls'
import { ReviewRowGroup } from 'dls/molecules/ReviewRows/types'
import { CopyComponent } from 'dls/molecules/Copy'

interface OwnProps {
  termsAndConditions: Document[]
}

const StyledWrapper = styled.div`
  width: 100%;
  dl {
    margin-bottom: 10px;
  }
  [data-dls='molecules-review-row']:last-child hr {
    display: none;
  }

  [data-dls='molecules-ReviewRow']:last-child {
    hr {
      display: none;
    }
    dl {
      margin-bottom: 0;
    }
  }
`

const UrlWrapper = styled.span`
  font-size: 12px !important;
`

const ViewTermsAndConditions = (props: OwnProps): React.ReactElement => {
  const { t } = useTranslation()
  const prodDetails: ReviewRowGroup[] = []

  if (!isEmpty(props.termsAndConditions) && props.termsAndConditions) {
    const termsAndConditionsLength = props.termsAndConditions.length - 1

    props.termsAndConditions.forEach((item, index) => {
      prodDetails[index] = {
        definitions: [],
      }

      if (index !== termsAndConditionsLength) prodDetails[index].groupSeparator = 'strong'

      if (item.name && item.version !== null && item.version) {
        prodDetails[index].definitions.push({
          term: <strong>{t('Name & version')}</strong>,
          itemSeparator: !item.description ? 'light' : undefined,
          definitions: [
            <strong key={`${kebabCase(item.name)}-${item.version}`}>
              {item.name} v{item.version}
            </strong>,
          ],
        })
      }
      if (item.description) {
        prodDetails[index].definitions.push({
          term: t('Description'),
          itemSeparator: 'light',
          definitions: [item.description],
        })
      }
      if (item.files) {
        item.files.forEach((file) => {
          prodDetails[index].definitions.push(
            {
              term: t('Label'),
              definitions: [file.label],
            },
            {
              term: t('Format'),
              definitions: [file.format],
            },
            {
              term: t('URL'),
              itemSeparator: 'light',
              definitions: [
                <>
                  <UrlWrapper>{file.url}</UrlWrapper>
                  <CopyComponent
                    onClickTitle="Copied"
                    payload={file.url}
                    tabIndex="0"
                    title="Copy"
                    style={{ top: -3 }}
                  />
                </>,
              ],
            }
          )
        })
      }
    })
  }

  return (
    <StyledWrapper>
      <ReviewRows definitionsList={prodDetails} />
    </StyledWrapper>
  )
}

export default ViewTermsAndConditions
